import { render, staticRenderFns } from "./router-join.vue?vue&type=template&id=1eb28b8d&"
import script from "./router-join.vue?vue&type=script&lang=js&"
export * from "./router-join.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports